import { subscribeComponent } from './subscribe.component';
import './subscribe.scss';

export const subscribe = angular
     .module('components.subscribe', [])
     .component('subscribe', subscribeComponent)
     .config(($stateProvider) => {
     	'ngInject';

     	$stateProvider
		.state('Subscribe', {
			url: '/subscribe',
			component: 'subscribe',
			breadcrumbName: 'Subscribe',
			parentState: 'Home',
			resolve: {
				breadcrumb(BreadcrumbService) {
					'ngInject';

					const breadcrumb = [{
						name: "Subscribe",
						display_name: "Subscribe",
						slug: ""
					}];

					BreadcrumbService.setPageBreadcrumbs(breadcrumb);
				}
			}
		});
     })
     .name;


// WEBPACK FOOTER //
// ./src/app/components/subscribe/subscribe.module.js